import './Icon_Check_Circle.css';
import {ReactComponent as CheckCircleIcon} from './Icons_CircleCheckmark_Outline_Brand.svg'
function Icon_Check_Circle() {
  return (
    <div className='icon-container-check-circle'>
      <CheckCircleIcon className="responsive-svg-check-circle" />
    </div>
  );
}

export default Icon_Check_Circle;